import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";

import sprite from "../../assets/img/sprite.svg";
import "./styles/style.scss";

// eslint-disable-next-line react/display-name
const SvgIcon = React.forwardRef(
  (
    {
      isAccent,
      hasBg,
      viewBox,
      width,
      height,
      size,
      name,
      textIcon,
      color,
      bg,
      direction,
      ...rest
    },
    innerRef
  ) => {
    /**
     * Вернуть класс, применяемый для размера иконки
     *
     * @param {String} value
     * @return {String}
     */
    const getSizeClass = value => {
      const classes = {
        xl: "icon--xl",
        lg: "icon--lg",
        md: "icon--md",
        sm: "icon--sm",
        custom: "icon--custom",
      };

      return _.get(classes, value, SvgIcon.defaultProps.size);
    };

    /**
     * Вернуть класс, применяемый для позиционирования компонента
     *
     * @param {String} value
     * @return {String}
     */
    const getDirectionClass = value => {
      const classes = {
        row: "icon-wrapper--row",
        column: "icon-wrapper--column",
      };

      return _.get(classes, value, SvgIcon.defaultProps.direction);
    };

    const classNames = [
      "icon",
      getSizeClass(size),
      (isAccent || textIcon) && "icon--accent",
      rest.className,
    ]
      .filter(name => name)
      .join(" ");

    let svg = null;
    if (typeof name === "string") {
      svg = (
        <svg
          viewBox={viewBox}
          width={width}
          height={height}
          fill="none"
          {...rest}
          className={classNames}
          ref={innerRef}
          xmlns="http://www.w3.org/2000/svg"
        >
          <use xlinkHref={`${sprite}#${name}`} style={{ fill: color }} />
        </svg>
      );
    } else {
      svg = (
        <div style={{ width: "24px", height: "24px" }}>
          <img src={name.logo} style={{ width: "100%" }} />
        </div>
      );
    }

    if (hasBg) {
      const classNames = ["icon-wrapper", getDirectionClass(direction)]
        .filter(name => name)
        .join(" ");

      return (
        <div className={classNames} style={{ backgroundColor: bg }}>
          {!textIcon ? svg : <div className="icon icon--accent icon--bold">{textIcon}</div>}
        </div>
      );
    } else {
      return svg;
    }
  }
);

SvgIcon.propTypes = {
  isAccent: PropTypes.bool,
  hasBg: PropTypes.bool,
  viewBox: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  size: PropTypes.string,
  name: PropTypes.any,
  textIcon: PropTypes.string,
  color: PropTypes.string,
  bg: PropTypes.string,
  direction: PropTypes.string,
  innerRef: PropTypes.object,
};

SvgIcon.defaultProps = {
  isAccent: false,
  hasBg: false,
  viewBox: "0 0 24 24",
  width: "24",
  height: "24",
  size: "xl",
  name: "",
  textIcon: "",
  color: "currentColor",
  bg: "",
  direction: "",
};

export default SvgIcon;
